<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          Update Sortition
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <sortition-form
              ref="form"
              v-model="sortition"
              :params="params"
              @submit="updateSortition"
            >
            </sortition-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="$router.push($routes.admin.sortitionDisplay.indexRoute)"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="updateSortition">
              Update
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {
  updateSortition,
  fetchSortition
} from "@/api/sortitionDisplay.api";
import SortitionCreateUpdate from "./SortitionDisplayCreateUpdate.js";

export default {
  name: "SortitionDisplayUpdate",
  extends: SortitionCreateUpdate,
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  watch: {
    $route() {
      this.$startLoading();
      this.fetchSortition(this.id);
      this.$finishedLoading();
    }
  },
  async mounted() {
    this.$startLoading();
    await Promise.all([this.fetchParams(), this.fetchSortition(this.id)]);
    this.$finishedLoading();
  },
  methods: {
    updateSortition() {
      const { sortition, $routes, $router, $refs } = this,
        sortitionToSend = {
          ...sortition,
          logo:
            this.sortition.logo && this.sortition.logo.normal
              ? null
              : sortition.logo,
          background:
            this.sortition.background && this.sortition.background.normal
              ? null
              : sortition.background
        };

      updateSortition(this.id, sortitionToSend)
        .then(() => {
          $router.push({
            name: $routes.admin.sortitionDisplay.indexRoute.name
          });
        })
        .catch(error =>
          this.handleErrorResponse($refs.validationObserver, error)
        );
    },
    async fetchSortition(sortitionId) {
      try {
        const { data } = await fetchSortition(sortitionId),
          { sortition } = data;

        this.sortition = sortition;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped></style>
